<template>
  <span class="houston-chip">
    <slot>
      This is a chip
    </slot>
    <Btn
      v-if="closable"
      class="show-on-hover"
      variant="bare"
      @click="() => $emit('close')"
    >
      <Icon id="close" :scale="0.5" />
    </Btn>
  </span>
</template>

<script>
/**
 * A small informative "chip" that can be closed, optionally.
 */
export default {
  props: {
    /** @type{import('vue').PropOptions<boolean>} Whether the chip has a "close" button appearing upon hovering */
    closable: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss">
.houston-chip {
  color: $brand-500;
  border: 1px solid $brand-500;
  padding: $btn-padding;
  line-height: 24px;
  background-color: $brand-50;
  border-radius: 24px;
  display: inline-flex;
  align-items: center;

  .show-on-hover {
    opacity: 0;
    transition: 0.1s ease-in-out;
    width: 1em;
    height: 1em;
    margin-left: 0;
    margin-right: -1em;
    line-height: 1;
    padding: 0;
  }

  &:hover .show-on-hover {
    opacity: 1;
    margin-left: 0.5em;
    margin-right: 0;
  }
}
</style>
